import { createContext, useContext, useState } from "react"

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const getIsLoggedIn = () => {
        const tokenString = sessionStorage.getItem('isLoggedIn');
        if(tokenString && tokenString !== 'undefined') return JSON.parse(tokenString);
        else return false;
    };

    const getDisplayName = () => {
        const tokenString = sessionStorage.getItem('displayName');
        if(tokenString && tokenString !== 'undefined') return JSON.parse(tokenString);
        else return null;
    };

    const getNonce = () => {
        const tokenString = sessionStorage.getItem('_wn');
        if(tokenString && tokenString !== 'undefined') return JSON.parse(tokenString);
        else return null;
    }

    const getEditable = () => {
        const tokenString = sessionStorage.getItem('editable');
        if(tokenString && tokenString !== 'undefined') return JSON.parse(tokenString);
        else return null;
    }

    const [isLoggedIn, setIsLoggedIn] = useState(getIsLoggedIn());
    const [displayName, setDisplayName] = useState(getDisplayName());
    const [nonce, setNonce] = useState(getNonce());
    const [editable, setEditable] = useState(getEditable());

    const login = (user) => {
        sessionStorage.setItem('isLoggedIn',JSON.stringify(user.isLoggedIn));
        sessionStorage.setItem('displayName',JSON.stringify(user.displayName));
        sessionStorage.setItem('_wn',JSON.stringify(user._wn));
        sessionStorage.setItem('editable',JSON.stringify(user.editable));
        setIsLoggedIn(user.isLoggedIn);
        setDisplayName(user.displayName);
        setNonce(user._wn);
        setEditable(user.editable);
    }

    const logout = () => {
        setIsLoggedIn(false);
        setDisplayName('');
        setNonce('');
        setEditable(false);
        sessionStorage.clear();
    }

    return (<AuthContext.Provider value={{ isLoggedIn, displayName, nonce, editable, login, logout}}> {children}  </AuthContext.Provider>)
};

export const useAuth = () => {
    return useContext(AuthContext)
};